import {createTranslationMessages} from '@backstage/core-plugin-api/alpha';
import {coreComponentsTranslationRef} from '@backstage/core-components/alpha';

export const coreComponentsPtbr = createTranslationMessages({
    ref: coreComponentsTranslationRef,
    messages: {
        "table.filter.title": "Filtros",
        "table.filter.placeholder": "Todos os resultados",
        "table.filter.clearAll": "Limpar tudo",
        "table.body.emptyDataSourceMessage": "Nenhum registro para exibir",
        "table.toolbar.search": "Filtrar",
        "table.pagination.firstTooltip": "Primeira Página",
        "table.pagination.labelDisplayedRows": "{from}-{to} de {count}",
        "table.pagination.labelRowsSelect": "linhas",
        "table.pagination.lastTooltip": "Última Página",
        "table.pagination.nextTooltip": "Próxima Página",
        "table.pagination.previousTooltip": "Página Anterior",
        "signIn.title": "Entrar",
        "signIn.loginFailed": "Falha no login",
        "signIn.customProvider.title": "Usuário Personalizado",
        "signIn.customProvider.subtitle": "Digite seu ID de usuário e credenciais.\n Esta seleção não será armazenada.",
        "signIn.customProvider.userId": "ID do Usuário",
        "signIn.customProvider.tokenInvalid": "Token não é um Token JWT OpenID Connect válido",
        "signIn.customProvider.continue": "Continuar",
        "signIn.customProvider.idToken": "Token de ID (opcional)",
        "signIn.guestProvider.title": "Convidado",
        "signIn.guestProvider.enter": "Entrar",
        "signIn.guestProvider.subtitle": "Entre como Usuário Convidado.\n Você não terá uma identidade verificada, o que significa que alguns recursos podem estar indisponíveis.",
        skipToContent: "Pular para o conteúdo",
        "copyTextButton.tooltipText": "Texto copiado para a área de transferência",
        "simpleStepper.finish": "Finalizar",
        "simpleStepper.reset": "Reiniciar",
        "simpleStepper.next": "Próximo",
        "simpleStepper.skip": "Pular",
        "simpleStepper.back": "Voltar",
        "errorPage.title": "Parece que alguém derrubou o microfone!",
        "errorPage.subtitle": "ERRO {{status}}: {{statusMessage}}",
        "errorPage.goBack": "Voltar",
        "errorPage.showMoreDetails": "Mostrar mais detalhes",
        "errorPage.showLessDetails": "Mostrar menos detalhes",
        "emptyState.missingAnnotation.title": "Anotação Ausente",
        "emptyState.missingAnnotation.actionTitle": "Adicione a anotação ao seu componente YAML como mostrado no exemplo destacado abaixo:",
        "emptyState.missingAnnotation.readMore": "Leia mais",
        "supportConfig.default.title": "Suporte Não Configurado",
        "supportConfig.default.linkTitle": "Adicionar chave de configuração `app.support`",
        "errorBoundary.title": "Por favor, contate {{slackChannel}} para obter ajuda.",
        "oauthRequestDialog.title": "Login Necessário",
        "oauthRequestDialog.authRedirectTitle": "Isso irá acionar um redirecionamento http para o Login OAuth.",
        "oauthRequestDialog.login": "Entrar",
        "oauthRequestDialog.rejectAll": "Rejeitar Tudo",
        "supportButton.title": "Suporte",
        "supportButton.close": "Fechar",
        "alertDisplay.message_one": "({{ count }} nova mensagem)",
        "alertDisplay.message_other": "({{ count }} novas mensagens)",
        "autoLogout.stillTherePrompt.title": "Saindo devido à inatividade",
        "autoLogout.stillTherePrompt.buttonText": "Sim! Não me desconecte",
        "proxiedSignInPage.title": "Você não parece estar conectado. Por favor, tente recarregar a página do navegador.",
    },
});

export default coreComponentsPtbr;
